const Header = {
    initBlock(el) {
        let isInitialized = false;
        const scope = el;
        const megaNav = el.querySelector("[data-mega-nav]");
        const navs = el.querySelectorAll("[data-nav]");
        const primaryNav = navs[0];
        const backLinks = primaryNav.querySelectorAll("[data-back]");
        let mobileNavIsShowing = mobileNavShowing();
        let openSubNav = null;
        if(!mobileNavIsShowing){
            showDesktopNav(() => {
                setTimeout(()=>{
                    isInitialized = true;  
                }, 600)
            });
        }else{
            isInitialized = true;
        }

        function handleEventOutside(e) {
            if (mobileNavShowing()) {
                if (primaryNav && !primaryNav.contains(e.target)) {
                    closeAllNavs();
                }
            }

            if (openSubNav && !openSubNav.contains(e.target)) {
                openSubNav.open = false;
                openSubNav = null;
            }

            if (e.key === "Escape" || e.key === "Esc") {
                closeAllNavs();
            }
        }

        primaryNav.addEventListener('toggle', (event) => primaryNav.setAttribute("aria-expanded", primaryNav.open));


        function checkMobileNavOnLoad() {
            const mobileMenu = primaryNav.querySelector(":scope > div");

            mobileMenu.classList.remove("hidden", "lg:block");
            if (mobileNavShowing()) {
                closeAllNavs();
            }
        }

        function refreshHeaderState() {
            if (!scope.hasAttribute("data-invert-header")) return;

            const isAtTop = (window.scrollY || document.body.scrollTop) === 0;

            // Check if any overlays are open
            const openNavs = Array.from(navs).filter((nav, index) => {
                // On desktop, the main nav (0) is always visible, so it's NOT an "overlay"
                if (!mobileNavShowing() && index === 0) return false;
                return nav.open;
            });

            const nothingIsOpen = openNavs.length === 0;

            // Header is Light ONLY if at top AND nothing is open
            const shouldBeLight = isAtTop && nothingIsOpen;

            toggleLightTheme(shouldBeLight);
            toggleHeaderHeight(isAtTop);
        }

        function bindEvents() {
            navs.forEach((nav, i) => {
                nav.addEventListener("toggle", () => {
                    if (mobileNavShowing()) {
                        focusOnOpenNav();
                    } else if (nav.open && i > 0) {
                        focusOnOpenNav();
                    }
                    const srOnly = nav.querySelector('.sr-only');
                    if (nav.open) {
                        ["click", "keyup"].forEach(event => document.addEventListener(event, handleEventOutside));
                        if (i > 0) {
                            openSubNav = nav;
                            if (!mobileNavShowing()) {
                                manageOverflow().setScrollbarWidth();
                            }
                        }
                        if(srOnly !== null) srOnly.innerHTML = 'Close Main Menu'
                    } else {
                        if (!primaryNav.open) {
                            ["click", "keyup"].forEach(event => document.removeEventListener(event, handleEventOutside));
                            closeAllNavs();
                        }
                        if (i > 0) {
                            if (!mobileNavShowing()) {
                                manageOverflow().clearScrollbarWidth();
                            }
                        }
                        if(srOnly !== null) srOnly.innerHTML = 'Open Main Menu'
                    }
                });
            });
            backLinks.forEach(link => {
                link.addEventListener("click", e => {
                    e.stopPropagation();
                    e.preventDefault();
                    closeSubNav(link);
                })
            })
            window.addEventListener("resize", () => {
                if (mobileNavIsShowing !== mobileNavShowing()) {
                    mobileNavIsShowing = mobileNavShowing();
                    if (mobileNavIsShowing) {
                        closeAllNavs();
                    } else {
                        showDesktopNav();
                    }
                    if (scope.hasAttribute("data-invert-header")) {
                        const openNavs = Array.from(navs).filter(n => n.open);
                        const nothingIsOpen = openNavs.length === 0;
                        const isAtTop = (window.scrollY || document.body.scrollTop) === 0;
                        if (!mobileNavShowing() && isAtTop) {
                            toggleLightTheme(nothingIsOpen);
                        }
                    }
                    refreshHeaderState();
                }
            });
            document.body.addEventListener("scroll", () => {
                toggleHeaderHeight(document.body.scrollTop === 0)
            });
        }

        function bindLightHeaderEvents() {
            // limit to mobile
            document.body.addEventListener("scroll", () => {
                toggleLightTheme(document.body.scrollTop === 0)
            });
            //toggle bg on nav open
            navs.forEach((nav, i) => {
                nav.addEventListener("toggle", e => {
                    if (!isInitialized || !e.isTrusted) return;

                    // 1. Find all navs that are currently open
                    const openNavs = Array.from(navs).filter((nav, index) => {
                        // If we are on desktop, ignore the main top-level nav (index 0)
                        // because it's ALWAYS open.
                        if (!mobileNavShowing() && index === 0) {
                            return false;
                        }
                        return nav.open;
                    });

                    // 2. We only want to go back to "Light/Inverted" mode if 
                    // NO menus are open AND we are at the top of the page.
                    const nothingIsOpen = openNavs.length === 0;
                    const isAtTop = (window.scrollY || document.body.scrollTop) === 0;
                    toggleLightTheme(nothingIsOpen && isAtTop);
                });
            });
        }

        function toggleLightTheme(condition) {
            scope.classList.toggle("bg-white", !condition);
            scope.classList.toggle("text-white", condition);
        }
        
        function toggleHeaderHeight(condition) {
            scope.style.setProperty("--header-height", condition ? "120px" : "80px");
            const logo = scope.querySelector('[data-header-logo]');
            if (logo) {
                logo.style.setProperty("--header-logo-height", condition ? "64px" : "56px");
            }
            scope.classList.toggle("header-scrolling", !condition);
        }

        function closeAllNavs() {
            navs.forEach((nav, i) => {
                if ((i === 0 && mobileNavShowing()) || (i > 0)) {
                    nav.open && nav.removeAttribute("open");
                }
            });
        }

        function closeSubNav(link) {
            link.closest("details").removeAttribute("open");
        }

        function focusOnOpenNav() {
            const focusableElements = "summary, button, a";
            const openNavs = Array.from(navs).filter((nav, index) => {
                // If we are on desktop, ignore the main top-level nav (index 0)
                // because it's ALWAYS open.
                if (!mobileNavShowing() && index === 0) {
                    return false;
                }
                return nav.open;
            });

            // Cancel if none are open
            if (openNavs.length === 0) return;

            const deepestNav = openNavs[openNavs.length - 1];

            if (!deepestNav) return;

            const elements = deepestNav.querySelectorAll(focusableElements);

            if (elements.length > 1) {
                let focusIndex = 1;

                while (focusIndex < elements.length && !elements[focusIndex].offsetParent) {
                    focusIndex++;
                }

                if (focusIndex < elements.length) {
                    elements[focusIndex].focus();
                }
            }

        }

        function mobileNavShowing() {
            return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 1024;
        }

        function showDesktopNav(callback) {
            if (primaryNav) {
                // If it's already open, we still want to fire the callback 
                // to set isInitialized = true
                if (primaryNav.open) {
                    if (callback) callback();
                    return;
                }

                // Otherwise, open it and then fire the callback
                primaryNav.setAttribute("open", "");

                if (callback) {
                    callback();
                }
            }
        }

        checkMobileNavOnLoad();

        bindEvents();
        
        if (scope.hasAttribute("data-invert-header")) {
            bindLightHeaderEvents();
        }
    }
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-header]").forEach(item => Header.initBlock(item));
});
